import { render, staticRenderFns } from "./AdminDataFixer.vue?vue&type=template&id=b7ad0e22&scoped=true"
import script from "./AdminDataFixer.vue?vue&type=script&lang=js"
export * from "./AdminDataFixer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ad0e22",
  null
  
)

export default component.exports